<template>
  <a-card>
    <a-tabs @change="handleChange" :animated="false" default-active-key="1">
      <a-tab-pane key="1" tab="委托" @click="_getWorkRecording">
        <a-list
          size="small"
          :data-source="list1"
          style="height: 282px; overflow-y: auto; padding: 0 16px;"
          :loading="loading"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <a-popconfirm
              slot="actions"
              title="是否取消委托?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="onCancel(item)"
            >
              <a-icon type="delete" />
            </a-popconfirm>
            <a-list-item-meta
              :description="`${item.indateStart} 至 ${item.indateEnd}`"
            >
              <a
                slot="title"
                href="javascript:;"
                class="work-link"
                @click="handleEdit(item)"
              >
                审批工作委托 - {{ item.agent }}
              </a>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <div style="padding: 5px 0;">
          <a-button type="link" @click="handleRecord">
            查看记录
            <a-icon type="arrow-right" />
          </a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="被委托" @click="_getDelegatedList">
        <a-list
          size="small"
          :data-source="list2"
          style="height: 282px; overflow-y: auto; padding: 0 16px;"
          :loading="loading"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta
              :description="`${item.indateStart} 至 ${item.indateEnd}`"
            >
              <a
                slot="title"
                href="javascript:;"
                class="work-link"
                @click="handleEdit(item)"
              >
                审批工作委托 - {{ item.owner }}
              </a>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <div style="padding: 5px 0;">
          <a-button type="link" @click="handleShowRecord">
            查看记录
            <a-icon type="arrow-right" />
          </a-button>
        </div>
      </a-tab-pane>
      <a-button
        class="margin-right-10"
        v-if="show === '1'"
        type="primary"
        size="small"
        @click="handleNew"
        slot="tabBarExtraContent"
      >
        新增委托
      </a-button>
    </a-tabs>

    <!--新增委托-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="visible = false"
      :afterClose="afterClose"
    >
      <a-form-model
        ref="form"
        :model="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 17 }"
        :rules="rules"
      >
        <a-form-model-item label="工作委托对象" prop="username">
          <a-select
            v-model="form.username"
            show-search
            :filter-option="filterOption"
            :disabled="show === '2'"
          >
            <a-select-option
              v-for="item in usernameList"
              :key="item.username"
              :value="item.username"
            >
              {{ item.name }} - {{ item.username }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="业务类型">
          <a-select
            v-model="form.business"
            placeholder="全部"
            allowClear
            @change="handleBusinessSelect"
            :disabled="show === '2'"
          >
            <a-select-option
              v-for="item in businessTypeList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="业务模式">
          <a-select
            v-model="form.mode"
            placeholder="全部"
            allowClear
            :disabled="show === '2'"
          >
            <a-select-option
              v-for="item in modeList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="工作委托时间" prop="indateRange">
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            style="width: 100%;"
            v-model="form.indateRange"
            :disabled="show === '2'"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--委托记录-->
    <a-modal
      title="委托记录"
      :width="950"
      :visible="recordingVisible"
      :footer="null"
      :maskClosable="false"
      @cancel="Cancelwt"
    >
      <div class="searchData">
        <a-form-model ref="searchForm" layout="vertical" :model="searchForm">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-model-item label="被委托人:" prop="agent">
                <a-input
                  placeholder="请输入被委托人"
                  v-model="searchForm.agent"
                  allowClear
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="日期:" prop="date">
                <a-date-picker
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  v-model="searchForm.date"
                  allowClear
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" style="text-align: right">
              <a-button
                type="primary"
                style="margin: 30px 10px"
                @click="handleRecord"
              >
                查询
              </a-button>
              <a-button @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <TableView
        :data="recordingData"
        :columns="recordingColumns"
        :pagination="recordingPageData"
        :scroll="{ x: 800 }"
        :loading="recordingTableLoading"
        @handlePagination="handleRecordingClickPage"
      >
        <template v-slot:active="{ tableRow }">
          <a-tag :color="STATUS_TYPE[tableRow.active].color">
            {{ STATUS_TYPE[tableRow.active].text }}
          </a-tag>
        </template>
      </TableView>
    </a-modal>
    <!--被委托记录-->
    <a-modal
      title="被委托记录"
      :width="950"
      :visible="recordingShowVisible"
      :footer="null"
      :maskClosable="false"
      @cancel="Cancel"
    >
      <div class="searchData">
        <a-form-model ref="searchData" layout="vertical" :model="searchData">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-model-item label="委托人:" prop="owner">
                <a-input
                  placeholder="请输入委托人"
                  v-model="searchData.owner"
                  allowClear
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="日期:" prop="date">
                <a-date-picker
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  v-model="searchData.date"
                  allowClear
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" style="text-align: right">
              <a-button
                type="primary"
                style="margin: 30px 10px"
                @click="handleShowRecord"
              >
                查询
              </a-button>
              <a-button @click="resetShow">重置</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <TableView
        :data="recordingShowData"
        :columns="recordingShowColumns"
        :pagination="recordingShowPageData"
        :scroll="{ x: 800 }"
        :loading="recordingShowTableLoading"
        @handlePagination="handleRecordingShowClickPage"
      >
        <template v-slot:active="{ tableRow }">
          <a-tag :color="STATUS_TYPE[tableRow.active].color">
            {{ STATUS_TYPE[tableRow.active].text }}
          </a-tag>
        </template>
      </TableView>
    </a-modal>
  </a-card>
</template>

<script>
import { ERR_OK } from '@/config'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import { TableView } from 'lxfintech-fe'
import {
  getWorkRecording,
  getDelegatedRecording,
  handleCancel,
  updateRecording,
  getWorkObject,
  getBusinessType,
  getDelegateRecording,
  getgateRecoeding,
} from '../api'

export default {
  name: 'DelegateTabs',
  data() {
    return {
      list: [],
      list1: [],
      list2: [],
      loading: false,
      form: {
        username: '',
        business: undefined,
        mode: undefined,
        indateRange: [],
        id: '',
      },
      searchForm: {
        agent: '',
        date: '',
      },
      searchData: { owner: '', date: '' },
      modeList: [],
      rules: {
        username: [
          {
            required: true,
            message: '请选择内容',
            trigger: 'change',
          },
        ],
        indateRange: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
      },
      modalTitle: '新增委托',
      usernameList: [],
      businessTypeList: [],
      visible: false,
      confirmLoading: false,
      recordingTableLoading: false,
      recordingPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      recordingShowPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      recordingShowData: [],
      recordingData: [],
      recordingShowTableLoading: false,
      recordingVisible: false,
      recordingShowVisible: false,
      recordingShowColumns: [
        {
          title: '委托人',
          width: 120,
          dataIndex: 'owner',
        },
        {
          title: '委托时间段',
          width: 220,
          customRender(text, record) {
            return `${record.indateStart}  ~  ${record.indateEnd}`
          },
        },
        {
          title: '业务类型',
          width: 200,
          dataIndex: 'business',
        },
        {
          title: '业务模式',
          width: 200,
          dataIndex: 'mode',
        },
        {
          title: '状态',
          width: 100,
          scopedSlots: { customRender: 'active' },
        },
      ],
      recordingColumns: [
        {
          title: '被委托人',
          width: 120,
          dataIndex: 'agent',
        },
        {
          title: '委托时间段',
          width: 220,
          customRender(text, record) {
            return `${record.indateStart}  ~  ${record.indateEnd}`
          },
        },
        {
          title: '业务类型',
          width: 200,
          dataIndex: 'business',
        },
        {
          title: '业务模式',
          width: 200,
          dataIndex: 'mode',
        },
        {
          title: '状态',
          width: 100,
          scopedSlots: { customRender: 'active' },
        },
      ],
      show: '1',
      STATUS_TYPE: {
        1: {
          color: 'green',
          text: '生效',
        },
        2: {
          color: 'red',
          text: '失效',
        },
        3: {
          color: 'orange',
          text: '取消',
        },
      },
    }
  },
  computed: {},
  mounted() {
    this._getWorkRecording()
    this._getDelegatedList()
    this._getWorkObject()
    this._getBusinessType()
  },
  methods: {
    Cancelwt() {
      this.recordingVisible = false
      this.$refs.searchForm.resetFields()
    },
    Cancel() {
      this.recordingShowVisible = false
      this.$refs.searchData.resetFields()
    },
    resetShow() {
      this.$refs.searchData.resetFields()
    },
    reset() {
      this.$refs.searchForm.resetFields()
    },
    _getWorkObject() {
      getWorkObject().then(({ data }) => {
        this.usernameList = data
      })
    },
    _getBusinessType() {
      getBusinessType().then(({ data }) => {
        this.businessTypeList = data
      })
    },
    handleChange(index) {
      this.show = index
    },
    // 获取委托记录
    async _getWorkRecording() {
      this.loading = true
      const { code, data } = await getWorkRecording()
      if (code === ERR_OK) {
        this.list1 = data
      }
      this.loading = false
    },

    // 获取被委托记录
    async _getDelegatedList() {
      this.loading = true
      const { code, data } = await getDelegatedRecording()
      if (code === ERR_OK) {
        this.list2 = data
      }
      this.loading = false
    },
    handleNew() {
      this.visible = true
      this.modalTitle = '新增委托'
    },
    handleEdit(data) {
      this.show === '1'
        ? (this.modalTitle = '编辑委托')
        : (this.modalTitle = '查看委托')
      for (const key in this.form) {
        if (data[key] == 0) {
          this.form[key] = undefined
        } else {
          this.form[key] = data[key]
        }
      }
      this.form.username = data.agent
      this.form.indateRange = [moment(data.indateStart), moment(data.indateEnd)]
      this.handleBusinessSelect(this.form.business)
      this.visible = true
    },
    handleBusinessSelect(value) {
      this.modeList = []
      const newArr =
        this.businessTypeList.filter(item => item.id === value)[0] || {}

      if (newArr.children) {
        this.modeList = newArr.children
      }
      // this.form.mode = undefined
      this.modeList.filter(item => item.id === this.form.mode)[0] || {}
    },
    handleOk() {
      if (this.show === '2') {
        this.visible = false
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          const formData = cloneDeep(this.form)

          formData.indateStart = formData.indateRange[0]
          formData.indateEnd = formData.indateRange[1]
          delete formData.indateRange

          for (const key in formData) {
            if (formData[key] == null) {
              formData[key] = 0
            }
          }
          updateRecording(formData).then(({ message }) => {
            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getWorkRecording()
            this.visible = false
          })
        }
      })
    },
    afterClose() {
      this.$refs.form.resetFields()
      for (const key in this.form) {
        this.form[key] = ''
      }
      this.form.business = undefined
      this.form.mode = undefined
      this.form.indateRange = []
    },
    onCancel({ id }) {
      handleCancel(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this.confirmLoading = false
        this._getWorkRecording()
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    handleRecord() {
      this.recordingTableLoading = true
      const { pageSize: size, current } = this.recordingPageData
      getDelegateRecording({ size, current, ...this.searchForm }).then(
        ({ data }) => {
          const { records, total } = data
          this.recordingData = records
          this.recordingTableLoading = false
          this.recordingPageData.total = total
          this.recordingVisible = true
        },
      )
    },
    handleShowRecord() {
      this.recordingShowTableLoading = true
      const { pageSize: size, current } = this.recordingShowPageData
      getgateRecoeding({ size, current, ...this.searchData }).then(
        ({ data }) => {
          const { records, total } = data
          this.recordingShowData = records
          this.recordingShowTableLoading = false
          this.recordingShowPageData.total = total
          this.recordingShowVisible = true
        },
      )
    },
    handleRecordingShowClickPage({ current, pageSize }) {
      this.recordingShowPageData = {
        ...this.recordingShowPageData,
        current,
        pageSize,
      }
      this.getgateRecoeding()
    },
    handleRecordingClickPage({ current, pageSize }) {
      this.recordingPageData = { ...this.recordingPageData, current, pageSize }
      this.handleDelegateRecording()
    },
    handleDelegateRecording() {
      this.recordingTableLoading = true

      const { pageSize: size, current } = this.recordingPageData
      getDelegateRecording({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.recordingData = records
        this.recordingTableLoading = false
        this.recordingPageData.total = total
        this.recordingVisible = true
      })
    },
    getgateRecoeding() {
      this.recordingShowTableLoading = true

      const { pageSize: size, current } = this.recordingShowPageData
      getgateRecoeding({ size, current }).then(({ data }) => {
        const { records, total } = data
        this.recordingShowData = records
        this.recordingShowTableLoading = false
        this.recordingShowPageData.total = total
        this.recordingShowVisible = true
      })
    },
  },
  components: {
    TableView,
  },
}
</script>

<style lang="less" scoped>
.hidden {
  visibility: hidden;
}
</style>
